import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';
import { faSort, faCog } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

const Table = props => {
    const { data, columns, isFullWidth, className } = props;

    const tableHeader = (
        <thead>
            <tr>
                {columns.map(column => {
                    if (column.type) {
                        switch(column.type){
                            case 'button':{
                                return (
                                    <th key={column.id} scope="col">
                                        <input type="button" {...column.attributes} value={column.text} onClick={column.handler} className={column.classes} /> 
                                    </th>
                                );
                            }
                            case 'link' : {
                                return (
                                    <th key={column.id} scope="col" style={{ whiteSpace: 'nowrap' }}>
                                        <a href={column.handler} className={column.classes}><FormattedMessage id={column.text} /></a>
                                        {
                                            column.isSortable &&
                                            <FontAwesomeIcon onClick={ column.sortableHandler } className='pointer' icon={faSort} />
                                        }
                                    </th>
                                );
                            }
                            case 'icon' : {
                                return (
                                    <th key={column.id} scope="col">
                                        <FontAwesomeIcon className='pointer' icon={faCog} />
                                    </th>
                                );
                            }
                        }                        
                    }else{
                        return (                    
                            <th key={column.id} scope="col">
                                {column.text}
                            </th>
                        );
                    }
                } )}
            </tr>
        </thead>
    );

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <div className='grid-row'>
            <a
                href=""
                className='grid-row flex-no-wrap flex-align-center'
                ref={ref}
                onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
                }}
            >
                {children}
                &#x25bc;
            </a>
        </div>
    ));

    CustomToggle.displayName = 'CustomToggle';

    const tableBody = (
        <tbody>
            {
                data.map((row, index) => {
                    const customClassRowOne = row.isCustomRender ? 'table__row__bb_0' : 'table__row';
                    const customClassRowTwo = row.isCustomRender ? 'table__row__bt_0' : 'table__row';
                    return <Fragment key={index} >
                        <tr className={customClassRowOne}>
                            {
                                columns.map((column, index) => (
                                    <td key={index}>
                                        { column.isLink ?
                                            <a href={row.url}>{row[column.id]}</a>
                                            :
                                            row[column.id]
                                        }
                                        { column.isIcon &&
                                            <span className='pointer'>
                                                <Dropdown size="sm">
                                                    <Dropdown.Toggle as={CustomToggle} id="dropdown-basic"  size='sm'>
                                                        <FontAwesomeIcon icon={column.icon} />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {
                                                            column.actions.map( action => <Dropdown.Item key={action} eventKey={action} href={row.iconUrl}>{action}</Dropdown.Item>)   
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </span>
                                        }
                                    </td>
                                ))}
                                
                        </tr>
                        { row.isCustomRender &&
                            <tr className={customClassRowTwo}>
                                <td colSpan={3}>
                                    { row.customRenderMessage }
                                </td>
                            </tr>
                        }

                    </Fragment>;

                })
            }
        </tbody>);

    return (
        <div className={`gi-table__responsive ${isFullWidth ? 'width-full' : ''} ${className}`}>
            <table className="usa-table usa-table--borderless gi-usa-table gi-table">
                {tableHeader}
                {tableBody}
            </table>
        </div>
    );
};

export default Table;